<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { FieldChange } from "@/model/change";
import { isUnset } from "@/model/change";

defineProps<{ field: FieldChange }>();
</script>

<template>
  <div class="change vertical change-value">
    <template v-if="!isUnset(field.old)">
      <div class="old">{{ field.old }}</div>
      <SvgIcon
        name="arrow/down"
        width="20"
        height="20"
        role="img"
        :aria-label="$t('label.cardDiff.changedTo')"
      />
    </template>
    <div class="new">{{ field.new }}</div>
  </div>
</template>
